import type { CityConfig } from "../city-template/types";

export const normalConfig: CityConfig = {
  city: "Normal",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "normal",
  route: "/normal",
  title: "Emergency Passport Normal, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Normal, Illinois — as fast as 24 hours. Fast passport renewal for Illinois State University students, Bloomington-Normal corporate travelers, and all McLean County residents. A+ BBB rated registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Normal, IL",
  heroSubtitle: "ISU student with a semester abroad in Spain and your passport expired? State Farm corporate traveler heading to Zurich on short notice? Twin-city with Bloomington — Illinois State University and global corporate headquarters but no passport agency for 2+ hours. We help Normal residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving Normal, Bloomington, and McLean County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Normal%20Illinois%20Illinois%20State%20University%20campus%20with%20the%20iconic%20Old%20Main%20Bell%20Tower%20and%20Fell%20Hall%20surrounded%20by%20red%20brick%20academic%20buildings%20and%20manicured%20quadrangles%2C%20Uptown%20Normal%20roundabout%20with%20charming%20shops%20and%20restaurants%2C%20Constitution%20Trail%20linear%20park%20with%20cyclists%20and%20joggers%20through%20the%20Bloomington%20Normal%20community%2C%20Central%20Illinois%20flat%20prairie%20landscape%20with%20golden%20sunset%20skies%2C%20classic%20Midwest%20college%20town%20atmosphere%20with%20warm%20evening%20light%2C%20professional%20landscape%20photography&width=1800&height=700&seq=normal-hero-001&orientation=landscape",
  heroImageAlt: "Normal Illinois Illinois State University campus and Uptown Normal at golden hour",
  geoPosition: "40.5142;-88.9906",
  geoPlacename: "Normal, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 2 hours 15 minutes northeast of Normal via I-55",
  },
  nearbyCitiesZips: [
    { name: "Normal", zips: "61761, 61790" },
    { name: "Bloomington", zips: "61701, 61704, 61705" },
    { name: "Hudson", zips: "61748" },
    { name: "Towanda", zips: "61776" },
    { name: "Lexington", zips: "61753" },
    { name: "Heyworth", zips: "61745" },
    { name: "Downs", zips: "61736" },
    { name: "Le Roy", zips: "61752" },
    { name: "Danvers", zips: "61732" },
    { name: "Colfax", zips: "61728" },
    { name: "Gridley", zips: "61744" },
    { name: "El Paso", zips: "61738" },
    { name: "Chenoa", zips: "61726" },
    { name: "Clinton", zips: "61727" },
    { name: "Farmer City", zips: "61842" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — about 2 hours 15 minutes away via I-55 but you skip the trip entirely" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Normal and McLean County travelers" },
    { icon: "ri-graduation-cap-line", title: "ISU Student Hub", desc: "Serving Illinois State University students and faculty with study abroad and international academic travel" },
    { icon: "ri-building-line", title: "Corporate Travel Hub", desc: "Serving State Farm, Rivian, and Bloomington-Normal corporate headquarters professionals" },
  ],
  internalLinks: [
    { name: "Expedited passport in Bloomington, IL", route: "/bloomington-il" },
    { name: "Emergency passport help in Peoria", route: "/peoria" },
    { name: "Urgent passport services in Champaign", route: "/champaign" },
    { name: "Illinois passport services overview", route: "/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Normal, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (about 2 hours 15 minutes northeast via I-55) — without you making the trip. Normal residents can ship from any UPS or FedEx in Normal or Bloomington. For Bloomington-Normal travelers, our courier service saves 4.5+ hours of highway driving and downtown Chicago navigation.",
  fpcOfficeDistance: "Serving Normal, Bloomington, Hudson, Towanda, Lexington, Heyworth, Downs, Le Roy, Danvers, Colfax, Gridley, El Paso, Chenoa, Clinton, Farmer City, and the entire McLean County area",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Normal and the entire Bloomington-Normal region. From the Illinois State University campus and Uptown Normal to the corporate headquarters corridor along Veterans Parkway, from the residential neighborhoods to the Constitution Trail communities — we serve the entire Normal community and McLean County.",
  nearbyCitiesIntro: "We serve Normal and all nearby communities including Bloomington, Hudson, Towanda, Lexington, Heyworth, Downs, Le Roy, Danvers, Colfax, Gridley, El Paso, Chenoa, Clinton, and Farmer City.",
  howItWorksIntro: "Most Normal travelers complete everything online and ship documents overnight. No need to drive over 2 hours to Chicago — our couriers handle the Chicago Passport Agency trip for you. For Bloomington-Normal residents, this saves a full workday of highway driving and downtown Chicago navigation.",
  mistakesIntro: "Normal is home to Illinois State University with extensive international programs and sits in the Bloomington-Normal corporate corridor — yet the nearest passport agency is over 2 hours away. Here are the most common passport mistakes in Normal and the McLean County area.",
  testimonialsIntro: "Normal travelers — from ISU Redbirds studying abroad and State Farm corporate travelers to McLean County families and Bloomington-Normal professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Normal, IL? Here are the most common ones we hear from Bloomington-Normal travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No 4.5+ hour Chicago round trip required", "Perfect for ISU study abroad deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "4.5+ hour round trip drive to Chicago", "Impractical for most McLean County residents"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Normal travelers with immediate departure needs — as fast as 24 hours. Essential for ISU study abroad deadlines and corporate business travel.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "No 4.5-hour Chicago round trip — ship locally"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Normal adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Normal address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Normal residents — including ISU students, new citizens, and McLean County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Normal residents who lost their passport before international travel, study abroad, or business trips.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Normal and McLean County area families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Normal and McLean County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized passport card for Normal residents who need land/sea travel to Canada or Mexico — ideal for quick North American trips.",
      bullets: ["Land and sea travel to Canada, Mexico, Caribbean", "Wallet-sized convenience", "REAL ID compliant"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Passport replacement for Normal residents with water-damaged, torn, or otherwise damaged passports that need urgent replacement.",
      bullets: ["DS-11 form with damage explanation", "Photo verification for identity matching", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Second valid passport book for Normal business travelers and frequent international flyers who need a backup while one is with an embassy.",
      bullets: ["Second valid passport book", "Ideal for frequent business travelers", "Keep traveling while visa processes"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Normal IL", description: "Urgent passport processing for Normal Illinois travelers and Illinois State University students with immediate departure needs." },
    { name: "Expedited Passport Renewal Normal IL", description: "Fast passport renewal for Normal Illinois residents and Bloomington-Normal travelers." },
    { name: "First-Time Passport Normal IL", description: "New passport application services for Normal Illinois residents." },
    { name: "Child Passport Normal IL", description: "Minor passport services for Normal Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Ashley R.",
      location: "Normal, IL — Illinois State University",
      rating: 5,
      text: "ISU's semester abroad in Spain was confirmed and I had 10 days to get my first passport. Fast Passport Center walked me through the DS-11 and I had it in 4 days. The Normal post office was convenient. Flying out of BMI to Chicago then Madrid. Every Redbird studying abroad needs to know about this — it's a lifesaver.",
      service: "First-Time Passport",
    },
    {
      name: "Thomas W.",
      location: "Normal, IL — State Farm Corporate",
      rating: 5,
      text: "Corporate trip to Zurich for State Farm — passport expired and I had 8 days. Fast Passport Center renewed it in 3 days. No way was I driving 4.5 hours round trip to Chicago. The courier service is the only practical option for Bloomington-Normal corporate travelers on tight timelines.",
      service: "Passport Renewal",
    },
    {
      name: "Linda P.",
      location: "Normal, IL",
      rating: 5,
      text: "Family trip to Ireland — needed my son's first passport and my renewal. Fast Passport Center coordinated both in 5 days. The Bloomington-Normal Public Library even had passport photo resources. McLean County families, don't stress about the Chicago drive — these folks make it effortless.",
      service: "Child & Renewal Passport",
    },
  ],
  facilities: [
    {
      id: "nor-1",
      name: "Normal Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 W North St",
      city: "Normal",
      state: "IL",
      zip: "61761",
      phone: "(309) 452-3956",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Normal, near Uptown Normal and the ISU campus",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Normal acceptance facility. Convenient to Illinois State University, Uptown Normal, and the Constitution Trail. Walking distance from ISU campus. Appointments recommended — this is popular with students during peak travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "nor-2",
      name: "Bloomington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1211 Towanda Ave",
      city: "Bloomington",
      state: "IL",
      zip: "61701",
      phone: "(309) 829-8007",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Bloomington, approximately 3 miles south of Normal",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Bloomington and southern Normal residents. Near Veterans Parkway and major shopping. Good alternative with generally more appointment availability than the Normal location.",
      icon: "ri-mail-line",
    },
    {
      id: "nor-3",
      name: "McLean County Circuit Clerk",
      type: "County Clerk Passport Acceptance",
      address: "104 W Front St, Room 404",
      city: "Bloomington",
      state: "IL",
      zip: "61701",
      phone: "(309) 888-5344",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Bloomington, McLean County Courthouse, downtown",
      website: "https://www.mcleancountyil.gov/",
      websiteLabel: "McLean County Circuit Clerk",
      notes: "McLean County acceptance facility at the county seat. Historic courthouse in downtown Bloomington. The only county clerk acceptance facility in the Bloomington-Normal area. Call ahead to confirm passport acceptance hours.",
      icon: "ri-government-line",
    },
    {
      id: "nor-4",
      name: "Lexington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 W Main St",
      city: "Lexington",
      state: "IL",
      zip: "61753",
      phone: "(309) 365-2221",
      hours: "Mon–Fri: 9:00 AM – 12:00 PM, 1:00 PM – 4:00 PM",
      distance: "Lexington, approximately 12 miles north of Normal",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lexington and northern McLean County residents. Smaller rural facility with limited hours — confirm availability before visiting. Good for northern county residents who want a closer option.",
      icon: "ri-mail-line",
    },
    {
      id: "nor-5",
      name: "Clinton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "105 N Quincy St",
      city: "Clinton",
      state: "IL",
      zip: "61727",
      phone: "(217) 935-5583",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Clinton, approximately 20 miles south of Normal",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Clinton and southern McLean County residents. DeWitt County seat facility. Good for residents near the southern McLean County border. Smaller facility — call ahead for passport hours.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2.25 hour drive to Chicago", fpc: "No — ship from Normal" },
    { feature: "Time Commitment", agency: "4.5+ hour round trip — full day lost", fpc: "Minutes — ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Practical for B-N", agency: "No — full day for the drive", fpc: "Yes — the smart fast solution" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "ISU Study Abroad Deadlines",
      description: "Illinois State University students regularly discover expired or missing passports just weeks before semester abroad programs. With Chicago over 2 hours away, students have few in-person emergency options. Our courier service is the fastest practical solution for ISU Redbirds.",
    },
    {
      icon: "ri-road-map-line",
      title: "Unnecessary Chicago Drive",
      description: "Many Bloomington-Normal residents think they can 'just drive to Chicago' for a passport emergency. At 2.25 hours each way plus downtown Chicago traffic and parking, this is a 4.5+ hour ordeal — an entire workday that most people simply cannot spare.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Validity Rule",
      description: "Many ISU students and Bloomington-Normal travelers don't know that numerous countries require 6 months of passport validity past the return date. A passport valid for 4 months is effectively expired for most European destinations popular with ISU study abroad programs.",
    },
    {
      icon: "ri-image-line",
      title: "ISU Student ID vs. Passport Photos",
      description: "ISU Redbird Cards do not meet Department of State passport photo standards. The lighting, background, and sizing requirements are completely different. Always use a dedicated passport photo service — Walgreens on Main Street does reliable passport photos.",
    },
    {
      icon: "ri-file-list-line",
      title: "Wrong Application Form",
      description: "Using DS-82 instead of DS-11 for first-time passports (or vice versa) is the #1 cause of rejection at Normal and Bloomington acceptance facilities. Our document review catches this before submission — especially important for first-time ISU student applicants.",
    },
    {
      icon: "ri-building-line",
      title: "Corporate Travel Time Crunch",
      description: "State Farm and other Bloomington-Normal corporate travelers sometimes get international assignments with little notice. The 4.5-hour Chicago round trip is impossible on a tight schedule. Our 24–48 hour courier service is the only fast option that works for Central Illinois corporate professionals.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Normal or McLean County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Uptown Normal or on Veterans Parkway." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with ISU study abroad, corporate travel, and McLean County family needs." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — about 2 hours 15 minutes away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Normal address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Normal, IL?", a: "Fast Passport Center offers emergency passport processing in Normal, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (about 2 hours 15 minutes northeast via I-55) — without you making the 4.5+ hour round trip. For Bloomington-Normal residents, this saves an entire workday of driving." },
    { q: "Does Normal have a passport agency?", a: "No — Normal does not have a regional passport agency. The nearest facility is the Chicago Passport Agency approximately 2 hours 15 minutes northeast via I-55. Fast Passport Center's courier service is the most practical fast option for Bloomington-Normal — especially for Illinois State University students who need their passports for study abroad." },
    { q: "Do you serve Illinois State University students?", a: "Absolutely. Fast Passport Center serves Illinois State University students, faculty, and staff. We understand semester abroad deadlines, international academic travel, and study abroad programs. Our 24–48 hour service is ideal for Redbirds who received last-minute acceptance to international programs." },
    { q: "What airport do Normal travelers use for international flights?", a: "Central Illinois Regional Airport (BMI) in nearby Bloomington offers regional connecting flights to Chicago, Dallas, and Atlanta. For most international flights, Bloomington-Normal travelers use Chicago O'Hare (ORD) — approximately 2 hours 15 minutes northeast via I-55. Some also use St. Louis Lambert (STL) — approximately 2 hours 15 minutes southwest via I-55." },
    { q: "Can corporate travelers use your passport services?", a: "Yes. Fast Passport Center serves State Farm, Rivian, Country Financial, and all Bloomington-Normal corporate travelers. We understand tight business travel timelines and can process in 24–48 hours for emergencies. The 4.5-hour Chicago round trip drive simply isn't practical on a corporate schedule." },
    { q: "What's the difference between Normal and Bloomington for passport services?", a: "Normal and Bloomington are twin cities sharing a border — together they form the Bloomington-Normal metropolitan area. Normal has Illinois State University and Uptown; Bloomington has the county courthouse and corporate headquarters. Both cities have USPS acceptance facilities. We serve both communities equally with the same expedited courier service." },
    { q: "Where can I get passport photos in Normal?", a: "Walgreens on Main Street, the UPS Store in Uptown Normal, and CVS on Veterans Parkway all offer passport photos. The Normal Post Office on North Street and Bloomington Post Office on Towanda Avenue also provide photo services. ISU's Bone Student Center may offer photos for students during peak travel seasons. Photos must be 2x2 inches on a white background." },
    { q: "Is there really no other fast option in Bloomington-Normal?", a: "Honestly — no. The Chicago Passport Agency is over 2 hours away and requires appointments booked weeks in advance for non-emergencies. For urgent international travel from Bloomington-Normal, Fast Passport Center's courier service is the only practical 24–48 hour option. It's why ISU students, State Farm travelers, and McLean County families rely on us." },
  ],
  photoLocations: [
    { name: "Walgreens — Normal", address: "1606 N Main St, Normal, IL 61761", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Uptown Normal", address: "107 W North St, Normal, IL 61761", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "CVS — Normal", address: "1701 E Empire St, Bloomington, IL 61704", hours: "Mon–Sun: 8AM–9PM" },
    { name: "Normal Post Office", address: "200 W North St, Normal, IL 61761", hours: "Mon–Fri: 9AM–4:30PM (photo services by appointment)" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Bloomington", address: "1510 W Market St, Bloomington, IL 61701", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Located in Bloomington — serving the entire Bloomington-Normal area. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Pontiac", address: "206 N Plum St, Pontiac, IL 61764", hours: "Mon–Fri: 8:00AM–4:30PM", note: "Alternative SOS facility serving Livingston County and eastern McLean County residents. REAL ID processing available. About 35 minutes from Normal via I-55 north.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for McLean County birth and death certificates" },
    { label: "Marriage Licenses (McLean County Clerk)", url: "https://www.mcleancountyil.gov/27/County-Clerk", desc: "McLean County Clerk — marriage license applications and certified copies for Normal and Bloomington-Normal" },
    { label: "Divorce Decrees (McLean County Circuit Clerk)", url: "https://www.mcleancountyil.gov/141/Circuit-Clerk", desc: "McLean County Circuit Clerk — divorce decree records for Normal and McLean County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "BMI",
      name: "Central Illinois Regional Airport",
      distance: "Approximately 10 minutes east of Normal via Veterans Parkway",
      address: "3201 Cira Dr, Bloomington, IL 61704",
      note: "Regional airport serving Bloomington-Normal with daily flights to Chicago O'Hare, Dallas-Fort Worth, Atlanta, and other major hubs. Convenient for domestic connections and regional travel. About 10 minutes from downtown Normal and ISU campus.",
      flightUrl: "https://www.cira.com/",
      flightLabel: "BMI Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 2 hours 15 minutes northeast via I-55",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub with extensive global connections. Most Bloomington-Normal international travelers and ISU study abroad students use ORD for direct international flights. About 2.25 hours from Normal.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "Approximately 2 hours 15 minutes southwest via I-55",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Alternative international airport for Bloomington-Normal travelers. Good for Southwest Airlines connections and some international routes. About 2.25 hours from Normal via I-55 south.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Flight Info",
      featured: false,
    },
  ],
};